import { render, staticRenderFns } from "./EvoCustomerDialog.vue?vue&type=template&id=310f953f&"
import script from "./EvoCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./EvoCustomerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports